import { h2bConfig, h2bMetaData, h2bPageSeo } from '@/brands/h2b/h2b.config';
import { ouroPixConfig, ouroPixMetaData } from '@/brands/ouroPix/ouroPix.config';
import {
  pixDoMilhaoConfig,
  pixDoMilhaoMetaData,
} from '@/brands/pixDoMilhao/pixDoMilhao.config';
import {
  sbtPremiosConfig,
  sbtPremiosMetaData,
} from '@/brands/sbtPremios/sbtPremios.config';
import { wepConfig, wePremiosMetaData } from '@/brands/wep/wep.config';

import { mspConfig, mspMetaData } from './msp/msp.config';
import {
  type BrandCode,
  type BrandPageSeo,
  type SeoPageKey,
  type WhitelabelConfig,
} from './types';

import type { Metadata } from 'next';

const brandMetadata: Record<BrandCode, Metadata> = {
  sbt: sbtPremiosMetaData,
  msp: mspMetaData,
  wep: wePremiosMetaData,
  demo: wePremiosMetaData,
  pdm: pixDoMilhaoMetaData,
  orp: ouroPixMetaData,
  h2b: h2bMetaData,
};

const brandPageSeo: Partial<Record<BrandCode, BrandPageSeo>> = {
  h2b: h2bPageSeo,
};

const brandConfig: Record<BrandCode, WhitelabelConfig> = {
  sbt: sbtPremiosConfig,
  msp: mspConfig,
  wep: wepConfig,
  demo: wepConfig,
  pdm: pixDoMilhaoConfig,
  orp: ouroPixConfig,
  h2b: h2bConfig,
};

function isBrandCode(value: string): value is BrandCode {
  return value in brandMetadata;
}

const whitelabel = process.env.NEXT_PUBLIC_WL_CODE;
export const brandCode: BrandCode =
  whitelabel && isBrandCode(whitelabel) ? whitelabel : 'sbt';

export const metadata: Metadata = brandMetadata[brandCode];
export const whitelabelConfig: WhitelabelConfig = brandConfig[brandCode];
export const pageSeo: BrandPageSeo | undefined = brandPageSeo[brandCode];

/**
 * Metadata (title + description) de uma página interna do brand ativo.
 * Usado nas `page.tsx` via `export const metadata = getPageMetadata('about')`.
 * O title é apenas o label; o sufixo "| <site>" vem do `title.template` do brand.
 * Só as marcas que definem `pageSeo` (atualmente apenas H2) recebem SEO por página;
 * nas demais retorna `{}` e a rota herda o metadata raiz do brand.
 */
export function getPageMetadata(key: SeoPageKey): Metadata {
  const seo = pageSeo?.[key];

  if (!seo) {
    return {};
  }

  return {
    title: seo.title,
    description: seo.description,
  };
}
